import React, {useEffect, useState} from "react";
import LevelItem from "../items/LevelItem";
import StatusItem from "../items/StatusItem";
import ExpirationDateItem from "../items/ExpirationDateItem";

const PlanSubHeaderDetails = ({levelItemTexts = [], expirationDate,
                          doesNotExpire, nextRenewalLevelName,
                          hasActiveFreeTrial, freeTrialExpirationDate}) => {
    return (
        <>
            {
                levelItemTexts.map((text, idx) => <LevelItem title={text} key={`level-item-${idx}`}/>)
            }
            <StatusItem expirationDate={expirationDate}
                        doesNotExpire={doesNotExpire}
                        hasActiveFreeTrial={hasActiveFreeTrial}
                        freeTrialExpirationDate={freeTrialExpirationDate}/>
            <ExpirationDateItem expirationDate={expirationDate}
                                doesNotExpire={doesNotExpire}
                                hasActiveFreeTrial={hasActiveFreeTrial}
                                freeTrialExpirationDate={freeTrialExpirationDate}
                                nextRenewalLevelName={nextRenewalLevelName}/>
        </>
    );
};

export default PlanSubHeaderDetails;